
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'displayProperties',
    pure: false
})
export class DisplayProperties implements PipeTransform {
    transform(obj, args: string[]): any {
      return  this.displayPropertiesWithValues(obj) ;
    }
    private  capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
   }
   private camelCaseToSpace(string) {
      return string.replace(/([a-z])([A-Z])/g, '$1 $2');
   }
   private displayPropertiesWithValues(obj) {
        let formatted = '';
         // tslint:disable-next-line:forin
        for (let key in obj) {
          if ( obj[key]) {
            let property = this.capitalizeFirstLetter(this.camelCaseToSpace(key));
            let value = obj[key];

            if (property === "Date Of Death") property = "Date of Death/Incident";
            if (value === "DateofDeath") value = "Date of Death/Incident";

            formatted = formatted + property  + ': ' +  value + ',  ';
          }
        }
        return formatted.replace(/,\s*$/, ''); // remove last comma
   }
}
